import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useMemo } from 'react';
import { JSX } from 'react';
import { Image } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { CDN_URL } from './API';

import './styles/site.scss';

interface SiteContainerProps{
	outlet: JSX.Element
}

var SiteContainer = (props: SiteContainerProps)=>{
	var { t } = useTranslation();
	var [params] = useSearchParams();

	useEffect(()=>{
		
	}, []);

	var website_id = useMemo(()=>{
		var w = params.get('w');
		if(!w || Number.isNaN(parseInt(w))) return null;
		else return parseInt(w);
	}, [params]);
	
	return <div className='ca main-container'>
		<div className={classNames('logo', {
			placeholder: website_id===null
		})}>
			{!!website_id ? (
				<Image src={`${CDN_URL}/websites/${website_id}.webp`} fallbackComponent={(
					<div className="bar"></div>
				)} />
			) : (
				<div className="bar"></div>
			)}
		</div>
		<div className="contents">
			{props.outlet}
		</div>
	</div>
}

export default SiteContainer;